import { useApi } from '#shared/providers/Api';
import useUsers from '../useUsers';
import unwrap from '../unwrap';
import { RolePayload } from '../types';

// The role endpoints take the permission keys as one comma-separated string.
function toRoleRequest(role: RolePayload) {
  return { ...role, Permissions: role.Permissions.join(',') };
}

export default function useCreateRole() {
  const api = useApi();
  const { account } = useUsers();

  async function createRole(role: RolePayload) {
    return unwrap(api.postCreateAccountUserRole(toRoleRequest(role), undefined, account.bearer));
  }

  return { createRole };
}
